import ExternalRedirect from '~/components/ExternalRedirect/ExternalRedirect';

export default ExternalRedirect;
